import isIOS from '../os/ios';
import __regexp from './__safari-regexp';
/** Detect Apple Safari Browser on iOS */
export default function isSafariIOS(ua) {
	return __regexp.test(ua) && isIOS(ua);
}
